module.exports = __webpack_public_path__ + "static/media/proj8_img3.651c1301.jpg";